
<textarea
  :ref="`textInputArea_child_${refId}`"
  rows="1"

  :value="textInput_child"
  :type="inputType"
  :placeholder="placeholder"

  class="input-area no-spinner"
  :class="focusBoxShadow ? `focus-box-shadow-and-border-color-687EFF textInputArea_child_${refId}` : `textInputArea_child_${refId}`"

  @input="textInput_child = $event.target.value; resize()"
></textarea>
  <!-- @keyup.enter="keyup_enter" -->
  <!-- @keyup.esc="keyup_esc" -->
  <!-- @keydown.tab.exact.prevent="onTab" -->
  <!-- @keydown.shift.tab.exact.prevent="onShiftTab" -->
